import { onFind } from '@elements/init-modules-in-scope';
import './scripts/common';
import {find, on} from '@elements/dom-utils';
import {deactivateScrollLock} from "@elements/scroll-lock";

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

import Tooltip from 'bootstrap/js/dist/tooltip';
onFind('[data-bs-toggle="tooltip"]',function (element) {
    new Tooltip(element);
});

import * as productGrid from './scripts/product-grid';
productGrid.init();

if (matchMedia('(max-width: 767px)').matches) {
    on('product-grid.changed', (evt) => {
        deactivateScrollLock();
    }, find('.js-product-grid'));
}

import * as productGridQuickFilter from './scripts/quick-filter';
productGridQuickFilter.init();

import * as dropdownPersist from './scripts/dropdown-persist';
dropdownPersist.init();

import * as overlay from './scripts/overlay';
overlay.init();

import * as filterForm from './scripts/ajax-form-animated';
filterForm.init();

import * as gallery from './scripts/gallery';
gallery.init();

import * as lightbox from '@elements/lightbox';
lightbox.init();

import * as afterLoadAnchorLink from './scripts/after-load-anchor-link';
afterLoadAnchorLink.init();